import React, { FC, useState } from "react";
// types
import { TClinicDetails } from "src/types";
// components
import Form from "./Form/Form";
import FormSuccess from "./FormSuccess/FormSuccess";
import FormWrong from "./FormWrong/FormWrong";

interface IClaimYourClinic {
  isOpen: boolean;
  clinic: TClinicDetails;
  handleCloseModal: () => void;
}

const ClaimYourClinic: FC<IClaimYourClinic> = ({ isOpen, clinic, handleCloseModal }) => {
  const [step, setStep] = useState<number>(1);

  const GoNext = () => {
    setStep(step + 1);
  };

  return (
    <>
      {step === 1 && (
        <Form
          clinic={clinic}
          handleCloseModal={handleCloseModal}
          GoNext={GoNext}
          isOpen={isOpen}
          setStep={setStep}
        />
      )}
      {step === 2 && <FormSuccess handleCloseModal={handleCloseModal} isOpen={isOpen} />}
      {step === 3 && (
        <FormWrong isOpen={isOpen} handleCloseModal={handleCloseModal} setStep={setStep} />
      )}
    </>
  );
};

export default ClaimYourClinic;
